import customers from "../data/customers";
import {track} from "./utils";

const _history = [];

const last = state => {
    const _current = _history.pop();

    if (_current.area === "EditorSimple") {
        return {area: state.images.origin.uploaded ? "CropPhoto" : "SelectBackground"};
    }

    if (_current.area === "SelectBackground" || _current.area === "CropPhoto") {
        return {area: "Landing"};
    }

    let _last;

    do {
        _last = _history.pop();
    } while (_last.area === _current.area);
    return _last;
};

const next = params => {
    _history.push(params);
    if (window.appMethod !== "script") {
        // TODO: bad global!
        window.location.hash = `area=${params.area}`;
        window.scrollTo(0, 0);
    }
};

const showBack = () => _history.length > 1;

const showVideo = () =>
    _history.length && _history[_history.length - 1].area === "Landing";

export const handleAddToBasket = (props, state) => {
    track.event("button", "click", "Add_To_Basket");
    setTimeout(() => {
        props.method === "redirect" && redirectToCallbackUrl(props, state);
        props.method === "script" && invokeCallback(props, state);
    }, 1000);
};

const redirectToCallbackUrl = (props, state) => {
    if (
        !customers[props.token] ||
        !validateCallbackUrl(customers[props.token].callbacks, props.callbackUrl)
    ) {
        alert("Callback URL not allowed");
        return;
    }

    let redirectUrl = `${props.callbackUrl}?${[
        "brandId",
        "productId",
        "token",
        "price",
        "currencyId",
        "locale"
    ]
        .map(key => `${key}=${props[key]}`)
        .join("&")}`;

    redirectUrl += `&${["labelId", "labelUrl"]
        .map(key => `${key}=${state[key]}`)
        .join("&")}`;

    if (Object.keys(props.custom).length) {
        redirectUrl += `&${Object.keys(props.custom)
            .map(key => `custom_${key}=${props.custom[key]}`)
            .join("&")}`;
    }

    window.location.href = redirectUrl;

    // process.env.REACT_APP_CALLBACK_NEW_WINDOW === "true"
    //   ? window.open(redirectUrl)
    //   : (window.location.href = redirectUrl);
};

const validateCallbackUrl = (alloweds, callbackUrl) => {
    if (alloweds === "*") {
        return true;
    }
    for (const value of alloweds) {
        if (value.indexOf(callbackUrl) === 0) {
            return true;
        }
    }
    return false;
};

const invokeCallback = (props, state) => {
    if (!customers[props.token]) {
        alert("Invalid token");
        return;
    }

    const response = {
        complete: true,
        brandId: props.brandId,
        productId: props.productId,
        token: props.token,
        price: props.price,
        currencyId: props.currencyId,
        locale: props.locale,
        custom: props.custom,
        labelId: state.labelId,
        labelUrl: state.labelUrl
    };
    window.DiageoPS.callback(response);
};

export default {last, next, showBack, showVideo, handleAddToBasket};



// WEBPACK FOOTER //
// ./src/misc/router.js